import { TextInput, type TextInputProps } from "./text-input";

export const SearchInput = (props: TextInputProps) => {
  return (
    <TextInput
      type="search"
      placeholder="Search..."
      rightIcon={<i className="fa-regular fa-magnifying-glass"></i>}
      {...props}
    />
  );
};
